import {useState } from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import CloseIcon from '@mui/icons-material/Close';

export default function MenuPopover(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <div>
      <Button variant="outlined" onClick={handleClick} endIcon={props.changed? <NewReleasesIcon/>:undefined}>
        {props.title}
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {props.closeIcon && <CloseIcon onClick={handleClose}/>}
        {props.children}
      </Popover>
    </div>
  );
}
